import { createSlice } from "@reduxjs/toolkit";

const doctorSlice = createSlice({
  name: "doctor",
  initialState: {
    doctorData: null,
    isGetDoctorLoading: false,
    isUpdateDoctorLoading: false,
    isGetDoctorByIdLoading: false,
  },
  reducers: {
    getDoctorLoading: (state) => {
      state.isGetDoctorLoading = true;
    },
    getDoctorSuccess: (state, action) => {
      state.doctorData = action.payload;
      state.isGetDoctorLoading = false;
    },
    getDoctorFailure: (state) => {
      state.isGetDoctorLoading = false;
    },
    // update
    updateDoctorLoading: (state) => {
      state.isUpdateDoctorLoading = true;
    },
    updateDoctorSuccess: (state, action) => {
      state.doctorData = action.payload;
      state.isUpdateDoctorLoading = false;
    },
    updateDoctorFailure: (state) => {
      state.isUpdateDoctorLoading = false;
    },
    // get by id
    getDoctorByIdLoading: (state) => {
      state.isGetDoctorByIdLoading = true;
    },
    getDoctorByIdSuccess: (state, action) => {
      state.singleDoctorData = action.payload;
      state.isGetDoctorByIdLoading = false;
    },
    getDoctorByIdFailure: (state) => {
      state.isGetDoctorByIdLoading = false;
    },
  },
});

export const {
  getDoctorLoading,
  getDoctorSuccess,
  getDoctorFailure,
  updateDoctorLoading,
  updateDoctorSuccess,
  updateDoctorFailure,
  getDoctorByIdLoading,
  getDoctorByIdSuccess,
  getDoctorByIdFailure,
} = doctorSlice.actions;

export default doctorSlice.reducer;
